export const LOGIN_ROUTE = "/login";
export const ORDERS_ROUTE = "/orders";
export const OVERVIEW_ROUTE = "/";
export const TUTORIAL_ROUTE = "https://mabriteccentral.com/upload-guides/";

// identification
export const IDENTIFICATION_UPLOAD = "/identification/upload";
export const IDENTIFICATION_ORDER = "/identification/order/:orderId";
export const IDENTIFICATION_SPECTRA_DETAILS_ROUTE =
  "/identification/spectra/:id";

// spectra quality
export const SPECTRA_QUALITY_UPLOAD = "/spectra-quality/upload";
export const SPECTRA_QUALITY_ORDER = "/spectra-quality/order/:orderId";
export const SPECTRA_QUALITY_SPECTRA_DETAILS_ROUTE =
  "/spectra-quality/spectra/:id";

// mosquito egg
export const MOSQUITO_VECTORS_UPLOAD = "/mosquito-vectors/upload";

// fungi ssp
export const FUNGI_SSP_UPLOAD = "/fungi-ssp/upload";

export const RESET_PASSWORD_ROUTE = "/reset-password";
export const RESET_PASSWORD_ACTION_ROUTE = "/action/reset-password";

// account
export const ACCOUNT_ROUTE = "/account";

// maco
export const MACO_MATCHES_ROUTE = "/maco/spectra/:id";
export const MACO_MATCHES_DETAILS_ROUTE = "/maco/spectra/:id/detail/:selectedProfile";
// A spectrum carried in the link fragment instead of stored (utils/maco-link.ts)
export const MACO_PEAKS_ROUTE = "/maco/peaks";
export const MACO_PEAKS_DETAILS_ROUTE = "/maco/peaks/detail/:selectedProfile";

// doku
export const DOCS_GLOSSARY_ROUTE = "/docs/glossary";
export const DOCS_GLOSSARY_ROUTE_SECTION = "/docs/glossary/:section";
export const DOCS_API_ROUTE = "/docs/api";
export const DOCS_SAMPLE_PREPARATION_ROUTE = "/docs/sample-preparation";

